import { selectActiveProjectId, useAppSelector } from '@core/core/store'
import { messengerRef } from 'common/messenger'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { lazy, useCallback, useState } from 'react'

import type { MicrofrontendProps } from '../../types'
import { TabWrapper } from '../TabWrapper'
import css from './GeoModuleMF.css'

const GeoModuleFront = lazy(() => import('@geoModule/GeoModule'))
const NavigatorFront = lazy(() => import('@dataManager/ResizableNavigator'))

export const GeoModuleMF: FC<MicrofrontendProps> = props => {
  const [divEl, setDivEl] = useState<Nullable<HTMLDivElement>>(null)
  const projectId = useAppSelector(selectActiveProjectId)
  const [isNavigatorModalOpened, setIsNavigatorModalOpened] = useState(false)

  const onToggleNavigatorModalOpen = useCallback((isOpen?: boolean) => {
    setIsNavigatorModalOpened(prev => (isOpen !== undefined ? isOpen : !prev))
  }, [])

  return (
    <div ref={setDivEl} className={css.container}>
      <TabWrapper>
        <GeoModuleFront
          projectId={projectId}
          geoModuleId={props.tabId as string}
          coreMessenger={messengerRef.current ?? undefined}
          onToggleNavigatorModalOpen={onToggleNavigatorModalOpen}
        />
        <NavigatorFront
          id={props.tabId as string}
          projectId={projectId}
          isModalOpen={isNavigatorModalOpened}
          parentElement={divEl}
          pinnedAt="TopRight"
          coreMessenger={messengerRef.current}
        />
      </TabWrapper>
    </div>
  )
}
